import * as React from "react";
import "./StatsTab.component.css";
import { useEffect, useState } from "react";
import { renderer } from "@modules/rendering/RendererGlobals";
import { mainScene } from "@modules/rendering/mainScene";
import { clockService } from "@modules/xr/ClockService";
import { localPlayerContainer } from "@modules/localplayer/LocalPlayerContainer";
import { getCameraPositionString, getCameraRotationString, getNumMatrixAutoUpdate, getNumVisibleObjectsAndMeshes, getVirtualPlatformPositionString } from "./StatsTab.utils";
import { FrameStatsMessage, ModuleId, RequestFrameStatsMessage } from "flavr-common";
import { busService } from "@modules/bus";
let interval;
export function StatsTab() {
    const [stdStats, setStdStats] = useState();
    const [collisionStats, setCollisionStats] = useState();
    useEffect(() => {
        updateStats();
        interval = window.setInterval(updateStats, 500);
        return () => {
            if (interval)
                window.clearInterval(interval);
        };
    }, []);
    const updateStats = () => {
        var _a, _b;
        setStdStats({
            memory: {
                geometries: renderer.info.memory.geometries,
                textures: renderer.info.memory.textures
            },
            render: {
                calls: renderer.info.render.calls,
                triangles: renderer.info.render.triangles,
                lines: renderer.info.render.lines,
                points: renderer.info.render.points
            },
            programs: {
                count: (_b = (_a = renderer.info.programs) === null || _a === void 0 ? void 0 : _a.length) !== null && _b !== void 0 ? _b : 0
            },
            config: {
                sceneAutoUpdate: mainScene.matrixWorldAutoUpdate,
                sortObjects: renderer.sortObjects,
                shadowMap: renderer.shadowMap.enabled
            },
            scene: {
                timeElapsed: clockService.getElapsedTime(),
                numMatrixAutoUpdate: getNumMatrixAutoUpdate(),
                numVisible: getNumVisibleObjectsAndMeshes(),
                cameraPos: getCameraPositionString(),
                cameraRot: getCameraRotationString(),
                virtualPlatformPos: getVirtualPlatformPositionString(),
                platformScale: localPlayerContainer.getPlatformScale(),
                worldScale: localPlayerContainer.getWorldScale()
            }
        });
        busService
            .connection("StatsTab")
            .ask(new RequestFrameStatsMessage(ModuleId.COLLISION), (messages) => {
            const msg = messages[0];
            if (!msg || !FrameStatsMessage.is(msg))
                return;
            setCollisionStats({
                fps: msg.fps,
                frameTime: msg.avgTime,
                rayTestTime: msg.frameTime
            });
        });
    };
    function createStatsRows(stdStats, collisionStats) {
        const rows = [];
        if (stdStats !== undefined) {
            rows.push(caption("Memory"));
            rows.push(row("Geometries", stdStats.memory.geometries));
            rows.push(row("Textures", stdStats.memory.textures));
            rows.push(caption("Render"));
            rows.push(row("Calls", stdStats.render.calls));
            rows.push(row("Triangles", stdStats.render.triangles));
            rows.push(row("Lines", stdStats.render.lines));
            rows.push(row("Points", stdStats.render.points));
            rows.push(caption("Programs"));
            rows.push(row("Count", stdStats.programs.count));
            rows.push(caption("Config"));
            rows.push(row("Scene auto update", stdStats.config.sceneAutoUpdate));
            rows.push(row("Sort objects", stdStats.config.sortObjects));
            rows.push(row("Shadow map", stdStats.config.shadowMap));
            rows.push(caption("Scene"));
            rows.push(row("Time elapsed (s)", stdStats.scene.timeElapsed.toFixed(2)));
            rows.push(row("Num matrix auto update", stdStats.scene.numMatrixAutoUpdate));
            rows.push(row("Num visible objects", stdStats.scene.numVisible.objects));
            rows.push(row("Num visible meshes", stdStats.scene.numVisible.meshes));
            rows.push(row("Camera pos", stdStats.scene.cameraPos));
            rows.push(row("VirtualPlatform pos", stdStats.scene.virtualPlatformPos));
            rows.push(row("Camera rot", stdStats.scene.cameraRot));
            rows.push(row("Platform scale", stdStats.scene.platformScale.toFixed(2)));
            rows.push(row("World scale", stdStats.scene.worldScale.toFixed(2)));
        }
        if (collisionStats) {
            rows.push(caption("Collision"));
            rows.push(row("FPS", collisionStats.fps.toFixed(2)));
            rows.push(row("Avg Ray test time (ms)", collisionStats.frameTime.toFixed(2)));
            rows.push(row("Ray test time (ms)", collisionStats.rayTestTime.toFixed(2)));
        }
        return rows;
    }
    const caption = (text) => (React.createElement("tr", { className: "stats-tab-caption-row", key: text },
        React.createElement("td", { colSpan: 2 }, text)));
    const row = (name, value) => (React.createElement("tr", { className: "stats-tab-value-row", key: name },
        React.createElement("td", null, name),
        React.createElement("td", null, String(value))));
    const allRows = createStatsRows(stdStats, collisionStats);
    const midpoint = Math.ceil(allRows.length / 2);
    const leftRows = allRows.slice(0, midpoint);
    const rightRows = allRows.slice(midpoint);
    return (React.createElement("div", { className: "stats-tab-container" },
        React.createElement("table", { className: "stats-tab-table" },
            React.createElement("tbody", null, leftRows)),
        React.createElement("table", { className: "stats-tab-table" },
            React.createElement("tbody", null, rightRows))));
}
